/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { StyledButton } from '@/components/atoms'
import { Footer, NavbarApp } from '@/components/molecules'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

const PrivacyPilicy = () => {
	const { t } = useTranslation('terms')
	const router = useRouter()

	const onToggleLanguageClick = () => {
		const changeTo = router.locale === 'en' ? 'id' : 'en'
		const { pathname, asPath, query } = router
		router.push({ pathname, query }, asPath, { locale: changeTo })
	}

	// <div
	//           dangerouslySetInnerHTML={{__html: t('privacyPolicy')}}
	//         />

	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('terms.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
						{t('terms.description')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-white md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto md:tw-mt-[90px] tw-mt-[30px] md:tw-mb-[100px] tw-md:px-0 tw-text-justify tw-px-4'>
						<h2 className='tw-text-xl tw-font-bold tw-mb-1'>
							{t('terms.point1.title')}
						</h2>
						<ol className='tw-list-decimal tw-ml-6 tw-mb-6'>
							<li className='tw-mb-4'>
								{t('terms.point1.1')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.2')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.3')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.4')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.5')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.6')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.7')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point1.8')}
							</li>
						</ol>

						<h2 className='tw-text-xl tw-font-bold tw-mb-1'>
							{t('terms.point2.title')}
						</h2>
						<ol className='tw-list-decimal tw-ml-6 tw-mb-6'>
							<li className='tw-mb-4'>
								{t('terms.point2.1')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.2.title')}
								<ul className='tw-list-disc tw-list-inside tw-mb-4'>
									<li className='tw-mb-4'>
										{t('terms.point2.2.1')}
									</li>
									<li className='tw-mb-4'>
										{t('terms.point2.2.2')}
									</li>
									<li className='tw-mb-4'>
										{t('terms.point2.2.3')}
									</li>
								</ul>
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.3')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.4')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.5')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.6')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.7')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.8')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point2.9')}
							</li>
						</ol>

						<h2 className='tw-text-xl tw-font-bold tw-mb-1'>
							{t('terms.point3.title')}
						</h2>
						<ol className='tw-list-decimal tw-ml-6 tw-mb-6'>
							<li className='tw-mb-4'>
								{t('terms.point3.1')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.2')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.3')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.4')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.5')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.6')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point3.7')}
							</li>
						</ol>

						<h2 className='tw-text-xl tw-font-bold tw-mb-1'>
							{t('terms.point4.title')}
						</h2>
						<ol className='tw-list-decimal tw-ml-6 tw-mb-6'>
							<li className='tw-mb-4'>
								{t('terms.point4.1')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point4.2')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point4.3')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point4.4')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point4.5')}
							</li>
							<li className='tw-mb-4'>
								{t('terms.point4.6')}
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PrivacyPilicy

export async function getStaticProps() {
	const locale = 'id'
	return {
		props: {
			...(await serverSideTranslations(locale, [
				'footer',
				'navbar',
				'terms',
			])),
		},
	}
}
